import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "many-to-one-handler",
  templateUrl: "./many-to-one-handler.component.html",
})
export class ManyToOneHandlerComponent implements OnInit, OnChanges {

  @Input() public lines: any[] = [];
  @Input() public transformationClass: any;
  @Input() public isLtr: boolean = true;
  @Output() public choosenLine = new EventEmitter();
  @Output() public deleteLine = new EventEmitter();

  public reordered: boolean = false;

  public ngOnInit(): void {
    this.initOrder();
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.initOrder();
  }

  public setLine(line) {
    this.choosenLine.emit(line);
  }

  public initOrder() {
    if (this.lines && this.lines[0].targetFieldProperties?.sortByFields?.length) {
      const sortByFields = this.lines[0].targetFieldProperties?.sortByFields;
      this.lines.forEach((l, i) => {
        const equiv = sortByFields.find((f) => {
          return f.id === l.field?.fieldKey;
        });
        l.order = equiv?.order || i;
      });
      this.lines.sort((a, b) => a.order - b.order);
      this.reordered = true;
    } else {
      this.reordered = true;
    }
  }

  public delLine(line) {
    this.deleteLine.emit(line.lineId);
  }

  public checkLineTransformations(line) {
    return this.checkTargetFieldProperties(line.targetFieldProperties) || this.checkDeterminant(line);
  }

  public checkTargetFieldProperties(targetFieldProperties) {
    return targetFieldProperties?.distinctByFields?.length ||
    targetFieldProperties?.groupByFields?.length ||
    targetFieldProperties?.inputTransformations?.length ||
    targetFieldProperties?.useAsExactSearch ||
    targetFieldProperties?.sortByFields?.length ||
    targetFieldProperties?.useAsFullTextSearch ||
    targetFieldProperties?.useAsStartsWith ||
    (targetFieldProperties?.fieldOperator?.length && targetFieldProperties?.fieldOperator !== "exact");
  }

  private checkDeterminant(field) {
    if (field.jsonDeterminant && JSON.stringify(field.jsonDeterminant) !== "[{\"type\":\"OR\",\"items\":[]}]") {
        return true;
    }
    if (field.jsonDeterminant?.jsonString && JSON.stringify(field.jsonDeterminant.jsonString) !== "[{\"type\":\"OR\",\"items\":[]}]") {
        return true;
    }
    if (field.jsonDeterminantFilter && JSON.stringify(field.jsonDeterminantFilter) !== "[{\"type\":\"OR\",\"items\":[]}]") {
        return true;
    }
    if (field.jsonDeterminantFilter?.jsonString && JSON.stringify(field.jsonDeterminantFilter?.jsonString) !== "[{\"type\":\"OR\",\"items\":[]}]") {
        return true;
    }
}

}
